"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ic_keyboard_arrow_down = void 0;
var ic_keyboard_arrow_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
    }
  }]
};
exports.ic_keyboard_arrow_down = ic_keyboard_arrow_down;